import { ThemeUIStyleObject } from "theme-ui";

const sxStyles: Record<"separator", ThemeUIStyleObject> = {
  separator: { color: "inherit" },
};

export default sxStyles;
